import * as AccessManagement from './AccessManagement';
import * as AngusServiceRequests from './AngusServiceRequests';
import * as Auth0SAML from './Auth0SAML';
import * as BuildingEnginesClassic from './BuildingEnginesClassic';
import * as BuildingEnginesPrism from './BuildingEnginesPrism';
import * as BuildingEnginesPrismVisitors from './BuildingEnginesPrismVisitors';
import * as Captivate from './Captivate';
import * as Cineplex from './Cineplex';
import * as EmailNotification from './EmailNotification/EmailUserInteractionChange';
import * as Essensys from './Essensys';
import * as FCPBot from './FCPBot';
import * as FloorMaps from './FloorMaps';
import * as Gallagher from './Gallagher';
import * as SaltoSVN from './SaltoSVN';
import * as GoogleCalendar from './GoogleCalendar';
import * as GoogleWorkplace from './GoogleWorkplace';
import * as HID from './HID';
import * as HOM from './HOM';
import * as Kastle from './Kastle';
import * as LiveSafe from './LiveSafe';
import * as MicrosoftAzure from './MicrosoftAzure';
import * as Newstand from './Newstand';
import * as Openpath from './Openpath';
import * as ParkWhiz from './ParkWhiz';
import * as Pattison from './Pattison';
import * as ProxyClick from './ProxyClick';
// Import directly from application-types (canonical source)
import { PointrDefinition, VantifyDefinition } from 'application-types';
import * as Ritual from './Ritual';
import * as SAML from './SAML';
import * as Safetrust from './Safetrust';
import * as ServiceRequest from './ServiceRequest';
import * as ShopifyBurst from './ShopifyBurst';
import * as ShopifyMultipass from './ShopifyMultipass';
import * as ShopifyRsvp from './ShopifyRsvp';
import * as SwiftConnect from './SwiftConnect';
import * as ThreeTenServ from './ThreeTenServ';
import * as YouRHere from './YouRHere';
import checkIntegrationSecurityRules from './checkIntegrationSecurityRules';
import * as getContentChannelIntegration from './getContentChannelIntegration';
import * as getSamlData from './SAML/getSamlData';

const Pointr = { definition: PointrDefinition } as const;
const Vantify = { definition: VantifyDefinition } as const;

export { default as getIntegrationDefinition } from './getIntegrationDefinition';
export { getIntegrationDisplayName } from './getIntegrationDefinition';

export {
  AccessManagement,
  AngusServiceRequests,
  Captivate,
  Cineplex,
  EmailNotification,
  Essensys,
  FCPBot,
  FloorMaps,
  Gallagher,
  GoogleCalendar,
  GoogleWorkplace,
  HID,
  HOM,
  Kastle,
  LiveSafe,
  Newstand,
  MicrosoftAzure,
  ParkWhiz,
  Pattison,
  Pointr,
  ProxyClick,
  ServiceRequest,
  ThreeTenServ,
  YouRHere,
  SAML,
  Auth0SAML,
  Safetrust,
  Openpath,
  SaltoSVN,
  ShopifyBurst,
  ShopifyRsvp,
  ShopifyMultipass,
  SwiftConnect,
  Ritual,
  BuildingEnginesPrism,
  BuildingEnginesPrismVisitors,
  BuildingEnginesClassic,
  getContentChannelIntegration,
  checkIntegrationSecurityRules,
  getSamlData,
  Vantify
};

export default {
  AccessManagement,
  AngusServiceRequests,
  Captivate,
  Cineplex,
  EmailNotification,
  Essensys,
  FCPBot,
  FloorMaps,
  Gallagher,
  GoogleCalendar,
  GoogleWorkplace,
  HID,
  HOM,
  Kastle,
  LiveSafe,
  MicrosoftAzure,
  Newstand,
  ParkWhiz,
  Pattison,
  Pointr,
  ProxyClick,
  ServiceRequest,
  ThreeTenServ,
  YouRHere,
  SAML,
  Auth0SAML,
  Safetrust,
  SaltoSVN,
  ShopifyBurst,
  ShopifyRsvp,
  ShopifyMultipass,
  SwiftConnect,
  Openpath,
  Ritual,
  BuildingEnginesPrism,
  BuildingEnginesPrismVisitors,
  BuildingEnginesClassic,
  getContentChannelIntegration,
  Vantify
};
